import type { VisibleNoTerritoryWarningV2 } from "@fate-kingdom/engine";

import warningEmblem from "../../assets/alpha/ui/warning-emblem.svg";
import { AlphaGameIcon } from "../icons/AlphaGameIcon";

export function NoTerritoryPresentation({
  warning,
  perspectivePlayerId,
  announcement,
}: {
  readonly warning: VisibleNoTerritoryWarningV2;
  readonly perspectivePlayerId: "player-1" | "player-2";
  readonly announcement: boolean;
}) {
  const threatened = warning.threatenedPlayerId === perspectivePlayerId;
  return (
    <>
      {announcement ? (
        <section className="alpha-no-territory-announcement" role="alert">
          <img src={warningEmblem} alt="" aria-hidden="true" />
          <small>Kingdom warning</small>
          <b>NO TERRITORY</b>
          <span>
            {threatened
              ? "Establish an active Land by the end of your next Land Phase."
              : "The opponent must establish an active Land by the end of its next Land Phase."}
          </span>
        </section>
      ) : null}
      <div className="alpha-no-territory-badge" role="status">
        <AlphaGameIcon name="land" aria-hidden="true" />
        <span>
          <b>No Territory</b>
          <small>{threatened ? "Restore a Land" : "Opponent threatened"}</small>
        </span>
      </div>
    </>
  );
}
